/*********************************************************************************
 * Copyright (C) 2025 VECROS Technologies Pvt. Ltd.
 * <legal@vecros.com>
 * This file is part of VECROS CLOUD SOFTWARE SERVICES maintained and developed by VECROS TECHNOLOGIES PRIVATE LIMITED.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 **********************************************************************************/
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { createStore, compose, applyMiddleware, combineReducers } from "redux";
import { thunk } from "redux-thunk";
import { Provider } from "react-redux";

import pageContextReducer from "./store/reducers/page-context";
import { LoaderProvider } from "./context/LoaderContext";

const composeEnhances = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// The auth slice is gone: the session is an httpOnly cookie owned by the API and
// surfaced through AuthContext. The store.subscribe() that used to live here
// also mirrored the entire state — id token included — into localStorage on
// every dispatched action.
const rootReducer = combineReducers({
  pageContext: pageContextReducer,
});

const store = createStore(rootReducer, composeEnhances(applyMiddleware(thunk)));

const app = (
  <Provider store={store}>
    <LoaderProvider>
      <App />
    </LoaderProvider>
  </Provider>
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(app);

serviceWorker.unregister();
